<script lang="ts">
  import { Accordion, AccordionItem } from "flowbite-svelte";
  import ExplainedContent from "./ExplainedContent.svelte";

  export let structure;
</script>

<div>
  <!-- <div>{JSON.stringify(structure)}</div> -->
  <h1 class="text-2xl mt-3">{@html structure["title"]}</h1>
  <!-- <div>{@html structure["introduction"]}</div> -->
  <ExplainedContent xmlContent={structure["introduction"]} />
  <Accordion class="mt-5" activeClass="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white">
    {#each structure["accordions"] as accordion}
      <AccordionItem paddingDefault="p-3 border-gray-400" borderSharedClass="border-gray-400 dark:border-gray-700">
        <span slot="header" class="text-lg text-black ">{accordion.label}</span>
        <ExplainedContent xmlContent={accordion.content} />
        <!-- <div>{@html accordion.content}</div> -->
      </AccordionItem>
    {/each}
  </Accordion>
</div>
